import { render, staticRenderFns } from "./BStandardCard.vue?vue&type=template&id=6e4f4700&scoped=true"
import script from "./BStandardCard.vue?vue&type=script&lang=js"
export * from "./BStandardCard.vue?vue&type=script&lang=js"
import style0 from "./BStandardCard.vue?vue&type=style&index=0&id=6e4f4700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f4700",
  null
  
)

export default component.exports